import PropTypes from "prop-types"

import chevronLeftBlack from "images/layout/chevron-left-black.svg"
import StripeJsContainer from "./stripe_js_container"
import PaymentInfoForm from "./payment_info_form"

import "./sign_up_and_purchase.scss"

export default function SignUpAndPurchase(props) {
  let tierName
  switch (props.tier) {
    case "pro":
      tierName = "Pro+"
      break
    case "intermediate_pro":
      tierName = "Pro"
  }

  const title = props.eligibleForTrial
    ? `Start 7-day trial`
    : `Upgrade to ${tierName}`

  const view = "checkout"
  const logLocationType =
    props.tier === "intermediate_pro"
      ? `intermediate_pro_${view}`
      : `pro_${view}`

  return (
    <StripeJsContainer>
      <header styleName="onboarding-header" className="pb2 pb0--phone">
        <div styleName="spacer">
          {!props.renderingInsideModal && (
            <button
              type="submit"
              className="button-tertiary button-outlined button-with-icon only-icon-on-mobile"
              aria-label="Back button"
              onClick={() => window.App.Scripts.BackButton()}
              data-track-ifttt-next-event="click"
              data-track-data={JSON.stringify({
                object_type: "back_link",
                location_type: logLocationType,
              })}
            >
              <span
                className="button-icon"
                dangerouslySetInnerHTML={{
                  __html: chevronLeftBlack,
                }}
              />
              <span className="hide-on-xs">Back</span>
            </button>
          )}
        </div>
        <h1>
          <img
            src={props.assets.iftttSvgUrl}
            alt="IFTTT logo"
            width="122"
            height="37"
          />
          {props.tier === "pro" ? (
            <img
              src={props.assets.proPlusBadgeSvgUrl}
              alt="Pro+ badge"
              width="91"
              height="53"
            />
          ) : (
            <img
              src={props.assets.proBadgeSvgUrl}
              alt="Pro badge"
              width="91"
              height="53"
            />
          )}
        </h1>
        <div styleName="spacer" />
      </header>
      <section className="welcome">
        <h1 className="mt4 mb4 mt0--phone">{title}</h1>
      </section>
      <div className="flexbox">
        <PaymentInfoForm {...props} logLocationType={logLocationType} />
      </div>
    </StripeJsContainer>
  )
}

SignUpAndPurchase.propTypes = {
  assets: PropTypes.shape({
    iftttSvgUrl: PropTypes.string.isRequired,
    proBadgeSvgUrl: PropTypes.string.isRequired,
    proPlusBadgeSvgUrl: PropTypes.string.isRequired,
  }),
  eligibleForTrial: PropTypes.bool,
  renderingInsideModal: PropTypes.bool.isRequired,
  tier: PropTypes.string.isRequired,
}

SignUpAndPurchase.defaultProps = {
  renderingInsideModal: false,
}
